import { render, staticRenderFns } from "./CustomTimeItems.vue?vue&type=template&id=afb308f4&scoped=true"
import script from "./CustomTimeItems.vue?vue&type=script&lang=js"
export * from "./CustomTimeItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb308f4",
  null
  
)

export default component.exports